<template>
  <LayoutContent>
    <app-page-title :title="$t('label.flashDeals')"></app-page-title>

    <v-card class="pa-4 my-6 rounded-lg" color="dark-green">
      <v-row no-gutters :justify="$vuetify.breakpoint.smAndUp ? 'space-between' : 'center'" align="center">
        <v-col cols="auto" align-self="center ">
          <div class="white--text font-weight-bold" :class="$vuetify.breakpoint.lgAndUp ? 'text-h5' : 'text-h6'">
            {{ $t('label.flashDealsPromoTitle') }}
          </div>
        </v-col>
        <!-- <v-spacer></v-spacer> -->
        <v-col cols="auto" align-self="center">
          <Timer :deadline="this.flashDealEndDate" />
        </v-col>
      </v-row>
    </v-card>

    <div>
      <v-row>
        <v-col v-for="product in flashDealProduct" :key="product.id" :xs="6" :sm="3" :md="3" :lg="2" :xl="2" :cols="6">
          <item :productInfo="product"></item>
        </v-col>
      </v-row>
    </div>
  </LayoutContent>
</template>
<script>
import Item from '@/components/product/Item.vue'
import Timer from '@/components/Timer.vue'
import LayoutContent from '../layouts/LayoutContent.vue'
export default {
  name: 'FlashDeals',
  components: {
    Timer,
    Item,
    LayoutContent
  },
  computed: {
    flashDealEndDate() {
      return this.$store.state.product.flashDealEndDate
    },
    flashDealProduct() {
      return this.$store.state.product.flashDealProduct
    }
  }
}
</script>
